import {
  KD_BUYER_CODE_DETAILS,
  KD_CHILD_PART_DETAILS,
  KD_DEPT_GRAPH_TABLE,
  KD_DI_DOWNLOAD,
  KD_DI_LOCATION_DETAILS,
  KD_DI_TABLE,
  KD_FILTER_BY_VENDOR,
  KD_MTD_DOWNLOAD,
  KD_MTD_TABLE,
  KD_PARENT_PART_DETAILS,
  KD_STOCK_DOWNLOAD,
  KD_STOCK_TABLE,
  KD_VENDOR_DETAILS,
  KD_VENDOR_GRAPH_TABLE,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getKDVendorDetails = (
  divisionList = null,
  deptList = null,
  page,
  search
) => {
  let requestURL = KD_VENDOR_DETAILS;
  let obj = {};
  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDDivisionDeptByVendor = (vendorList = null) => {
  const requestURL = KD_FILTER_BY_VENDOR;
  let obj = {};

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDBuyerCodeDetails = (
  divisionList = null,
  deptList = null,
  page,
  search
) => {
  let requestURL = KD_BUYER_CODE_DETAILS;
  let obj = {};
  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDDiLocation = () => {
  const requestURL = KD_DI_LOCATION_DETAILS;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDParentPartDetails = (
  deptList = null,
  vendorList = null,
  divisionList = null,
  page,
  search
) => {
  let requestURL = KD_PARENT_PART_DETAILS;
  let obj = {};
  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDChildPartDetails = (
  deptList = null,
  vendorList = null,
  divisionList = null,
  page,
  search
) => {
  let requestURL = KD_CHILD_PART_DETAILS;
  let obj = {};
  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDDeptGraphTable = (
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
  page,
  limit
) => {
  let requestURL = KD_DEPT_GRAPH_TABLE;
  let obj = {};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (limit) {
    obj["limit"] = limit;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDVendorGraphTable = (
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
  page,
  limit
) => {
  let requestURL = KD_VENDOR_GRAPH_TABLE;
  let obj = {};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (limit) {
    obj["limit"] = limit;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDStockTable = (
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
  page,
  limit
) => {
  let requestURL = KD_STOCK_TABLE;
  let obj = {};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (page) {
    obj["page"] = page;
  }

  if (limit) {
    obj["limit"] = limit;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDDITable = (
  parentPartId = null,
  view,
  month,
  year,
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
  page,
  limit
) => {
  let requestURL = `${KD_DI_TABLE}/${parentPartId}`;
  let obj = {view: view};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  if (page) {
    obj["page"] = page;
  }

  if (limit) {
    obj["limit"] = limit;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDMTDTable = (
  childPartId = null,
  view,
  month,
  year,
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
  page,
  limit
) => {
  let requestURL = `${KD_MTD_TABLE}/${childPartId}`;
  let obj = {view: view};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  if (page) {
    obj["page"] = page;
  }

  if (limit) {
    obj["limit"] = limit;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDStockReport = (
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
) => {
  let requestURL = KD_STOCK_DOWNLOAD;
  let obj = {};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDDIReport = (
  parentPartId = null,
  month,
  year,
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
) => {
  let requestURL = `${KD_DI_DOWNLOAD}/${parentPartId}`;
  let obj = {};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getKDMTDReport = (
  childPartId = null,
  month,
  year,
  divisionList = null,
  deptList = null,
  vendorList = null,
  buyerList = null,
  locationList = null,
  parentPartList = null,
  childPartList = null,
) => {
  let requestURL = `${KD_MTD_DOWNLOAD}/${childPartId}`;
  let obj = {};

  if (divisionList && divisionList.length) {
    obj["division_list"] = divisionList.join(",");
  }

  if (deptList && deptList.length) {
    obj["dept_list"] = deptList.join(",");
  }

  if (vendorList && vendorList.length) {
    obj["vendor_list"] = vendorList.join(",");
  }

  if (buyerList && buyerList.length) {
    obj["buyer_list"] = buyerList.join(",");
  }

  if (locationList && locationList.length) {
    obj["location_list"] = locationList.join(",");
  }

  if (parentPartList && parentPartList.length) {
    obj["parent_part_list"] = parentPartList.join(",");
  }

  if (childPartList && childPartList.length) {
    obj["child_part_list"] = childPartList.join(",");
  }

  if (month) {
    obj["month"] = month;
  }

  if (year) {
    obj["year"] = year;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
